export const DEFAULT_KANBAN_COLUMNS = [
  { headerText: 'To Do', keyField: 1, isSystem: true },
  { headerText: 'In Progress', keyField: 2, isSystem: true },
  { headerText: 'Completed', keyField: 3, isSystem: true },
  { headerText: 'Archived', keyField: 4, isSystem: true },
]

export const createDefaultKanbanColumns = () =>
  DEFAULT_KANBAN_COLUMNS.map((column) => ({ ...column }))

export const toNumericStatusId = (value) => {
  if (value === null || value === undefined || value === '') return null

  const numericValue = Number(value)
  return Number.isSafeInteger(numericValue) ? numericValue : null
}

export const normalizeKanbanColumns = (columns = []) => {
  const safeColumns = Array.isArray(columns) ? columns : []
  const mappedColumns = safeColumns
    .map((column) => {
      const headerText = String(
        column?.headerText ||
          column?.HeaderText ||
          column?.name ||
          column?.Name ||
          column?.StatusName ||
          column?.Status ||
          column?.status ||
          column?.keyField ||
          '',
      ).trim()
      if (!headerText) return null

      return {
        ...column,
        headerText,
        originalKeyField:
          column?.originalKeyField ??
          column?.keyField ??
          column?.KeyField ??
          column?.StatusId ??
          column?.StatusID ??
          column?.statusId ??
          column?.id ??
          column?.Id ??
          headerText,
        numericKeyField: toNumericStatusId(
          column?.keyField ??
            column?.KeyField ??
            column?.StatusId ??
            column?.StatusID ??
            column?.statusId ??
            column?.id ??
            column?.Id,
        ),
      }
    })
    .filter(Boolean)

  const usedIds = new Set()

  return mappedColumns.map((column, index) => {
    let keyField = column.numericKeyField

    if (keyField === null || usedIds.has(String(keyField))) {
      keyField = index + 1
      while (usedIds.has(String(keyField))) {
        keyField += 1
      }
    }

    usedIds.add(String(keyField))

    const { numericKeyField, ...normalizedColumn } = column
    return {
      ...normalizedColumn,
      keyField,
    }
  })
}

export const findKanbanStatusColumn = (columns = [], statusId, statusLabel) => {
  const normalizedColumns = normalizeKanbanColumns(columns)
  const normalizedStatusId = statusId === null || statusId === undefined ? '' : String(statusId)
  const normalizedStatusText = normalizedStatusId.trim().toLowerCase()
  const normalizedStatusLabel = String(statusLabel || '').trim().toLowerCase()

  return (
    (normalizedStatusId &&
      normalizedColumns.find(
        (column) =>
          String(column.keyField) === normalizedStatusId ||
          String(column.originalKeyField) === normalizedStatusId ||
          String(column.headerText || '').trim().toLowerCase() === normalizedStatusText ||
          String(column.originalKeyField || '').trim().toLowerCase() === normalizedStatusText,
      )) ||
    (normalizedStatusLabel &&
      normalizedColumns.find(
        (column) => String(column.headerText || '').trim().toLowerCase() === normalizedStatusLabel,
      )) ||
    normalizedColumns[0] ||
    null
  )
}
